import { render, staticRenderFns } from "./addQueue.vue?vue&type=template&id=71cb834b&scoped=true&"
import script from "./addQueue.vue?vue&type=script&lang=js&"
export * from "./addQueue.vue?vue&type=script&lang=js&"
import style0 from "./addQueue.vue?vue&type=style&index=0&id=71cb834b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb834b",
  null
  
)

export default component.exports